var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticStyle:{"float":"left","width":"100%","height":"100%"},attrs:{"src":_vm.VodUrl,"poster":_vm.poster,"controls":"controls","controlslist":"nodownload"}})}
var staticRenderFns = []

export { render, staticRenderFns }